<h1 mat-dialog-title>Priorität einstellen</h1>

<div mat-dialog-content>
    <h3>Wählen Sie die Priorität des Tickets aus:</h3>
    <mat-form-field style="width: 100%">
        <mat-label>Priorität</mat-label>
        <mat-select [formControl]="selectPriorityCtrl" placeholder="Priorität" required>
            <mat-option *ngFor="let priority of prioritaeten" [value]="priority"
                >{{ priority.bezeichnung }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>

<div align="end" mat-dialog-actions>
    <button (click)="dialogRef.close()" mat-button>Abbrechen</button>
    <button (click)="closeDialog()" [disabled]="isSaving" color="accent" mat-flat-button>Priorität Festlegen</button>
</div>
